<div
  class="lp-root"
  [lang]="currentLanguage.code"
  [attr.dir]="currentLanguage.direction"
  [class.rtl]="currentLanguage.direction === 'rtl'"
  [style.--lp-px.px]="heroParallax().x"
  [style.--lp-py.px]="heroParallax().y"
>
  <!-- ═══════════════════════════════════════════════════════════════════
       0. HEADER STICKY GLASSMORPHISM
       ═══════════════════════════════════════════════════════════════════ -->
  <header class="lp-header" [class.is-scrolled]="isScrolled()" role="banner">
    <div class="lp-header-inner">
      <a class="lp-brand" routerLink="/" aria-label="vendeur.site">
        <app-brand-logo size="sm" [animated]="true"></app-brand-logo>
        <span class="lp-brand-word">
          vendeur<span class="lp-brand-dot">.</span>site
        </span>
      </a>

      <nav class="lp-nav" [class.is-open]="mobileMenuOpen()" aria-label="Navigation principale">
        <button class="lp-nav-link" type="button" (click)="scrollToSection('lp-features')">
          {{ translate('lp_nav_features') }}
        </button>
        <button class="lp-nav-link" type="button" (click)="scrollToSection('lp-steps')">
          {{ translate('lp_nav_steps') }}
        </button>
        <button class="lp-nav-link" type="button" (click)="scrollToSection('lp-pricing')">
          {{ translate('lp_nav_pricing') }}
        </button>
        <button class="lp-nav-link" type="button" (click)="scrollToSection('lp-testimonials')">
          {{ translate('lp_nav_testimonials') }}
        </button>
        <button class="lp-nav-link" type="button" (click)="scrollToSection('lp-faq')">
          {{ translate('lp_nav_faq') }}
        </button>

        <div class="lp-nav-divider" aria-hidden="true"></div>

        <div class="lp-lang-picker">
          <span class="material-icons-outlined" aria-hidden="true">language</span>
          <select (change)="changeLanguage($event)" [attr.aria-label]="translate('lp_nav_features')">
            <option *ngFor="let lang of availableLanguages" [value]="lang.code" [selected]="lang.code === currentLanguage.code">
              {{ lang.name }}
            </option>
          </select>
        </div>

        <button class="lp-theme-toggle" type="button" (click)="toggleTheme()" [attr.aria-label]="isDark() ? 'Light mode' : 'Dark mode'">
          <span class="material-icons-outlined">{{ isDark() ? 'light_mode' : 'dark_mode' }}</span>
        </button>

        <a routerLink="/login" class="lp-btn lp-btn-ghost lp-nav-cta">
          {{ translate('lp_nav_login') }}
        </a>
        <a routerLink="/signup" class="lp-btn lp-btn-primary lp-nav-cta">
          <span class="material-icons-outlined" aria-hidden="true">rocket_launch</span>
          {{ translate('lp_nav_signup') }}
        </a>
      </nav>

      <button class="lp-burger" type="button" (click)="toggleMobileMenu()" [class.is-open]="mobileMenuOpen()" aria-label="Menu" [attr.aria-expanded]="mobileMenuOpen()">
        <span></span><span></span><span></span>
      </button>

      <!-- Backdrop : ferme le menu latéral au clic/tap en dehors -->
      <div
        class="lp-nav-backdrop"
        [class.is-visible]="mobileMenuOpen()"
        (click)="closeMobileMenu()"
        aria-hidden="true"
      ></div>
    </div>
  </header>

  <main class="lp-main">

    <!-- ═══════════════════════════════════════════════════════════════
         1. HERO IMMERSIF
         ═══════════════════════════════════════════════════════════════ -->
    <section class="lp-hero" id="lp-hero">
      <!-- Couverture VIDÉO 3D générée par IA (AtlasCloud wan-2.5) — fond animé
           du hero, fondu depuis le poster, coupée si prefers-reduced-motion. -->
      <div class="lp-hero-video-wrap" aria-hidden="true" *ngIf="motionOk()">
        <video
          class="lp-hero-video"
          [class.is-ready]="heroVideoReady()"
          autoplay muted loop playsinline
          preload="metadata"
          poster="/assets/landing/hero-cover-poster.jpg"
          (canplay)="heroVideoReady.set(true)"
        >
          <source src="/assets/landing/hero-cover.mp4" type="video/mp4" media="(min-width: 720px)" />
          <source src="/assets/landing/hero-cover-mobile.mp4" type="video/mp4" />
        </video>
        <div class="lp-hero-video-veil"></div>
      </div>

      <div class="lp-orb lp-orb-1" aria-hidden="true"></div>
      <div class="lp-orb lp-orb-2" aria-hidden="true"></div>
      <div class="lp-orb lp-orb-3" aria-hidden="true"></div>
      <div class="lp-orb lp-orb-4" aria-hidden="true"></div>
      <div class="lp-hero-grid-bg" aria-hidden="true"></div>
      <div class="lp-hero-noise" aria-hidden="true"></div>

      <div *ngIf="showConfetti()" class="lp-confetti-layer" aria-hidden="true">
        <span *ngFor="let i of confettiParticles; trackBy: trackByIndex" class="lp-confetti-particle" [attr.data-i]="i"></span>
      </div>

      <div class="lp-hero-inner">
        <div class="lp-hero-left">
          <span class="lp-hero-eyebrow">
            <span class="lp-live-dot" aria-hidden="true"></span>
            {{ translate('lp_hero_eyebrow') }}
          </span>

          <h1 class="lp-hero-title">
            {{ translate('lp_hero_title_pre') }}
            <span class="lp-gradient-text">{{ translate('lp_hero_title_highlight') }}</span>
            {{ translate('lp_hero_title_post') }}
          </h1>

          <p class="lp-hero-sub">{{ translate('lp_hero_subtitle') }}</p>

          <div class="lp-hero-cta">
            <a routerLink="/signup" class="lp-btn lp-btn-primary lp-btn-lg">
              <span class="material-icons-outlined" aria-hidden="true">rocket_launch</span>
              {{ translate('lp_hero_cta_primary') }}
            </a>
            <button type="button" class="lp-btn lp-btn-glass lp-btn-lg" (click)="scrollToSection('lp-demo')">
              <span class="material-icons-outlined" aria-hidden="true">play_circle</span>
              {{ translate('lp_hero_cta_secondary') }}
            </button>
          </div>

          <div class="lp-stat-row" aria-label="Statistiques">
            <div class="lp-stat-chip" *ngFor="let s of stats; trackBy: trackByIndex">
              <span class="lp-stat-chip-icon material-icons-outlined" aria-hidden="true">{{ s.icon }}</span>
              <span class="lp-stat-chip-val">
                {{ statValues()[s.key] }}<span class="lp-stat-chip-suffix">{{ s.suffix }}</span>
              </span>
              <span class="lp-stat-chip-label">{{ translate(s.labelKey) }}</span>
            </div>
          </div>
        </div>

        <!-- Mockup browser + chat IA overlay -->
        <aside class="lp-hero-mockup" aria-label="Aperçu site builder IA">
          <div class="lp-browser">
            <div class="lp-browser-bar">
              <span class="lp-browser-dot" style="background:#ff5f57"></span>
              <span class="lp-browser-dot" style="background:#febc2e"></span>
              <span class="lp-browser-dot" style="background:#28c840"></span>
              <span class="lp-browser-url">
                <span class="material-icons-outlined" aria-hidden="true">lock</span>
                monstore.vendeur.site
              </span>
            </div>
            <div class="lp-browser-body" [style.--mock-color]="heroMockColor()">
              <div class="lp-mock-badge" *ngIf="heroMockBadge()">
                <span class="material-icons-outlined" aria-hidden="true">local_offer</span>
                {{ heroMockBadge() }}
              </div>
              <!-- Vitrine simulée : visuels produits générés par IA (AtlasCloud),
                   self-hostés — la boutique « prend vie » au lieu de skeletons. -->
              <div class="lp-mock-hero" [class.is-promoted]="heroMockHero()">
                <div class="lp-mock-hero-img lp-mock-hero-img-photo">
                  <img [src]="mockHeroProduct.img" [alt]="translate(mockHeroProduct.nameKey)"
                       width="880" height="587" loading="eager" decoding="async" />
                </div>
                <div class="lp-mock-hero-text">
                  <span class="lp-mock-prod-name">{{ translate(mockHeroProduct.nameKey) }}</span>
                  <span class="lp-mock-prod-price">{{ mockHeroProduct.price }}</span>
                  <div class="lp-mock-skel lp-mock-skel-line"></div>
                  <div class="lp-mock-btn lp-mock-btn-labeled">{{ translate('lp_mock_add_to_cart') }}</div>
                </div>
              </div>
              <div class="lp-mock-grid">
                <div class="lp-mock-card" *ngFor="let p of mockProducts; trackBy: trackByIndex">
                  <div class="lp-mock-card-img lp-mock-card-img-photo">
                    <img [src]="p.img" [alt]="translate(p.nameKey)"
                         width="880" height="880" loading="lazy" decoding="async" />
                  </div>
                  <span class="lp-mock-prod-name">{{ translate(p.nameKey) }}</span>
                  <span class="lp-mock-prod-price">{{ p.price }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="lp-hero-chat" aria-hidden="true">
            <div class="lp-hero-chat-head">
              <span class="material-icons-outlined">auto_awesome</span>
              <strong>Vendeur.site IA</strong>
              <span class="lp-hero-chat-dot"></span>
            </div>
            <div class="lp-hero-chat-body">
              <div *ngFor="let m of heroMockMessages(); trackBy: trackByIndex"
                   class="lp-hero-chat-bubble"
                   [class.is-user]="m.role === 'user'"
                   [class.is-ai]="m.role === 'ai'">
                <span class="lp-hero-chat-text">{{ m.text }}</span>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </section>

    <!-- ═══════════════════════════════════════════════════════════════
         1 bis. CINÉ-CTA — vidéo 3D IA interactive (hotspots cliquables)
         ═══════════════════════════════════════════════════════════════ -->
    <section class="lp-section lp-cinema lp-reveal" id="lp-cinema" aria-labelledby="lp-cinema-title">
      <header class="lp-section-head">
        <span class="lp-eyebrow">{{ translate('lp_cinema_eyebrow') }}</span>
        <h2 class="lp-section-title" id="lp-cinema-title">{{ translate('lp_cinema_title') }}</h2>
        <p class="lp-section-sub">{{ translate('lp_cinema_sub') }}</p>
      </header>

      <div
        class="lp-cinema-stage"
        #cinemaStage
        (mousemove)="onCinemaMove($event, cinemaStage)"
        (mouseleave)="onCinemaLeave()"
      >
        <div
          class="lp-cinema-frame"
          [style.transform]="'perspective(1200px) rotateX(' + cinemaTilt().rx + 'deg) rotateY(' + cinemaTilt().ry + 'deg)'"
          [style.--lp-glare-x.%]="cinemaTilt().gx"
          [style.--lp-glare-y.%]="cinemaTilt().gy"
        >
          <video
            #cinemaVideo
            class="lp-cinema-video"
            loop muted playsinline
            preload="metadata"
            poster="/assets/landing/cta-cinema-poster.jpg"
            (loadedmetadata)="onCinemaMeta(cinemaVideo)"
            (timeupdate)="onCinemaTime(cinemaVideo)"
            (click)="toggleCinema(cinemaVideo)"
          >
            <source src="/assets/landing/cta-cinema.mp4" type="video/mp4" />
          </video>

          <!-- Reflet dynamique suivant le pointeur (verre 3D) -->
          <div class="lp-cinema-glare" aria-hidden="true"></div>

          <!-- Lancement : grand CTA play au centre (état initial / pause) -->
          <button
            *ngIf="!cinemaPlaying()"
            type="button"
            class="lp-cinema-play"
            (click)="toggleCinema(cinemaVideo)"
            [attr.aria-label]="translate('lp_cinema_play')"
          >
            <span class="lp-cinema-play-ring" aria-hidden="true"></span>
            <span class="material-icons-outlined" aria-hidden="true">play_arrow</span>
            <span class="lp-cinema-play-label">{{ translate('lp_cinema_play') }}</span>
          </button>

          <!-- HOTSPOTS CTA cliquables SUR la vidéo (fenêtres temporelles) -->
          <button
            *ngFor="let h of visibleHotspots(); trackBy: trackByIndex"
            type="button"
            class="lp-cinema-hotspot"
            [style.left.%]="h.x"
            [style.top.%]="h.y"
            (click)="cinemaHotspotAction(h, $event)"
          >
            <span class="lp-hotspot-dot" aria-hidden="true"></span>
            <span class="lp-hotspot-pill">
              <span class="material-icons-outlined" aria-hidden="true">{{ h.icon }}</span>
              {{ translate(h.labelKey) }}
              <span class="material-icons-outlined lp-hotspot-arrow" aria-hidden="true">arrow_forward</span>
            </span>
          </button>

          <!-- Timeline chapitrée cliquable (seek) -->
          <div class="lp-cinema-bar" *ngIf="cinemaStarted()">
            <div class="lp-cinema-progress" [style.width.%]="cinemaProgress()"></div>
            <button
              *ngFor="let c of cinemaChapters; trackBy: trackByIndex"
              type="button"
              class="lp-cinema-chapter"
              [class.is-passed]="cinemaTime() >= c.at"
              [style.left.%]="(c.at / cinemaDuration()) * 100"
              (click)="seekChapter(cinemaVideo, c.at, $event)"
              [title]="translate(c.labelKey)"
            >
              <span class="material-icons-outlined" aria-hidden="true">{{ c.icon }}</span>
            </button>
          </div>
        </div>

        <!-- Légende chapitres sous le cadre -->
        <div class="lp-cinema-caption" *ngIf="cinemaStarted()">
          <span *ngFor="let c of cinemaChapters; trackBy: trackByIndex"
                class="lp-cinema-caption-item"
                [class.is-active]="cinemaTime() >= c.at">
            <span class="material-icons-outlined" aria-hidden="true">{{ c.icon }}</span>
            {{ translate(c.labelKey) }}
          </span>
        </div>
      </div>
    </section>

    <!-- ═══════════════════════════════════════════════════════════════
         2. TRUST LOGOS — MARQUEE
         ═══════════════════════════════════════════════════════════════ -->
    <section class="lp-trust lp-reveal" aria-label="Logos clients">
      <p class="lp-trust-title">{{ translate('lp_trust_title') }}</p>
      <div class="lp-marquee" role="list">
        <div class="lp-marquee-track">
          <div class="lp-marquee-item" *ngFor="let logo of trustLogos; trackBy: trackByIndex" role="listitem">
            <span class="material-icons-outlined" aria-hidden="true">{{ logo.icon }}</span>
            <span>{{ logo.name }}</span>
          </div>
          <div class="lp-marquee-item" *ngFor="let logo of trustLogos; trackBy: trackByIndex" role="listitem" aria-hidden="true">
            <span class="material-icons-outlined">{{ logo.icon }}</span>
            <span>{{ logo.name }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ═══════════════════════════════════════════════════════════════
         3. FEATURES GRID
         ═══════════════════════════════════════════════════════════════ -->
    <section class="lp-section lp-features lp-reveal" id="lp-features" aria-labelledby="lp-features-title">
      <header class="lp-section-head">
        <span class="lp-eyebrow">{{ translate('lp_nav_features') }}</span>
        <h2 class="lp-section-title" id="lp-features-title">{{ translate('lp_features_title') }}</h2>
        <p class="lp-section-sub">{{ translate('lp_features_subtitle') }}</p>
      </header>

      <div class="lp-feature-grid">
        <article *ngFor="let f of features; let i = index; trackBy: trackByIndex"
                 class="lp-feature-card lp-reveal"
                 [class.is-soon]="f.comingSoon"
                 [attr.data-tone]="f.tone"
                 [style.--lp-stagger]="i * 60 + 'ms'">
          <span *ngIf="f.comingSoon" class="lp-feature-soon">
            {{ translate('lp_feature_soon_badge') }}
          </span>
          <div class="lp-feature-icon-wrap">
            <span class="material-icons-outlined lp-feature-icon" aria-hidden="true">{{ f.icon }}</span>
            <span class="lp-feature-icon-glow" aria-hidden="true"></span>
          </div>
          <h3 class="lp-feature-title">{{ translate(f.titleKey) }}</h3>
          <p class="lp-feature-desc">{{ translate(f.descKey) }}</p>
          <span class="lp-feature-more">
            {{ translate(f.comingSoon ? 'lp_feature_notify_me' : 'lp_feature_learn_more') }}
            <span class="material-icons-outlined" aria-hidden="true">arrow_forward</span>
          </span>
        </article>
      </div>
    </section>

    <!-- ═══════════════════════════════════════════════════════════════
         3 bis. TIKTOK COMING SOON — section dédiée pour conversion
         ═══════════════════════════════════════════════════════════════ -->
    <section class="lp-section lp-tiktok-section lp-reveal" id="lp-tiktok" aria-labelledby="lp-tiktok-title">
      <header class="lp-section-head">
        <span class="lp-eyebrow lp-eyebrow-tiktok">{{ translate('lp_feature_soon_badge') }}</span>
        <h2 class="lp-section-title" id="lp-tiktok-title">{{ translate('lp_feature_tiktok_title') }}</h2>
        <p class="lp-section-sub">{{ translate('lp_feature_tiktok_desc') }}</p>
      </header>

      <div class="lp-tiktok-stage">
        <app-tiktok-coming-soon mode="section"></app-tiktok-coming-soon>
      </div>
    </section>

    <!-- ═══════════════════════════════════════════════════════════════
         4. STEPS — Comment ça marche
         ═══════════════════════════════════════════════════════════════ -->
    <section class="lp-section lp-steps lp-reveal" id="lp-steps" aria-labelledby="lp-steps-title">
      <header class="lp-section-head">
        <span class="lp-eyebrow">{{ translate('lp_nav_steps') }}</span>
        <h2 class="lp-section-title" id="lp-steps-title">{{ translate('lp_steps_title') }}</h2>
        <p class="lp-section-sub">{{ translate('lp_steps_subtitle') }}</p>
      </header>

      <ol class="lp-step-list">
        <li *ngFor="let s of steps; let i = index; trackBy: trackByIndex"
            class="lp-step lp-reveal"
            [class.is-reverse]="i % 2 === 1"
            [style.--lp-stagger]="i * 80 + 'ms'">
          <div class="lp-step-content">
            <span class="lp-step-num">{{ i + 1 }}</span>
            <span class="lp-step-icon material-icons-outlined" aria-hidden="true">{{ s.icon }}</span>
            <h3 class="lp-step-title">{{ translate(s.titleKey) }}</h3>
            <p class="lp-step-desc">{{ translate(s.descKey) }}</p>
          </div>
          <div class="lp-step-illu" aria-hidden="true">
            <ng-container [ngSwitch]="s.illustration">
              <div *ngSwitchCase="'wizard'" class="lp-illu lp-illu-wizard">
                <div class="lp-illu-step"><span class="material-icons-outlined">looks_one</span>Nom</div>
                <div class="lp-illu-step"><span class="material-icons-outlined">looks_two</span>Branding</div>
                <div class="lp-illu-step"><span class="material-icons-outlined">looks_3</span>Pages</div>
              </div>
              <div *ngSwitchCase="'ai'" class="lp-illu lp-illu-ai">
                <div class="lp-illu-ai-orb"></div>
                <div class="lp-illu-ai-orb"></div>
                <div class="lp-illu-ai-orb"></div>
                <div class="lp-illu-ai-label">
                  <span class="material-icons-outlined">auto_awesome</span>
                  Claude Opus 4.5
                </div>
              </div>
              <div *ngSwitchCase="'chat'" class="lp-illu lp-illu-chat">
                <div class="lp-illu-bubble lp-illu-bubble-user">{{ translate('lp_demo_user_color') }}</div>
                <div class="lp-illu-bubble lp-illu-bubble-ai">{{ translate('lp_illu_chat_done') }}</div>
                <div class="lp-illu-bubble lp-illu-bubble-user">{{ translate('lp_demo_user_promo') }}</div>
              </div>
              <div *ngSwitchCase="'rocket'" class="lp-illu lp-illu-rocket">
                <span class="material-icons-outlined lp-illu-rocket-ic">rocket_launch</span>
                <div class="lp-illu-rocket-trail"></div>
                <div class="lp-illu-rocket-url">vous.vendeur.site</div>
              </div>
            </ng-container>
          </div>
        </li>
      </ol>
    </section>

    <!-- ═══════════════════════════════════════════════════════════════
         5. DÉMO INTERACTIVE
         ═══════════════════════════════════════════════════════════════ -->
    <section class="lp-section lp-demo lp-reveal" id="lp-demo" aria-labelledby="lp-demo-title">
      <header class="lp-section-head">
        <span class="lp-eyebrow">Live demo</span>
        <h2 class="lp-section-title" id="lp-demo-title">{{ translate('lp_demo_title') }}</h2>
        <p class="lp-section-sub">{{ translate('lp_demo_subtitle') }}</p>
      </header>

      <div class="lp-demo-grid">
        <div class="lp-browser lp-demo-browser" [style.--mock-color]="demoColor()">
          <div class="lp-browser-bar">
            <span class="lp-browser-dot" style="background:#ff5f57"></span>
            <span class="lp-browser-dot" style="background:#febc2e"></span>
            <span class="lp-browser-dot" style="background:#28c840"></span>
            <span class="lp-browser-url">
              <span class="material-icons-outlined" aria-hidden="true">lock</span>
              {{ translate('lp_demo_browser_url') }}
            </span>
          </div>
          <div class="lp-browser-body">
            <div class="lp-mock-badge" *ngIf="demoBadge()">
              <span class="material-icons-outlined" aria-hidden="true">local_offer</span>
              {{ demoBadge() }}
            </div>
            <div class="lp-mock-hero" [class.is-promoted]="demoHero()">
              <div class="lp-mock-hero-img lp-mock-hero-img-photo">
                <img [src]="mockHeroProduct.img" [alt]="translate(mockHeroProduct.nameKey)"
                     width="880" height="587" loading="lazy" decoding="async" />
              </div>
              <div class="lp-mock-hero-text">
                <span class="lp-mock-prod-name">{{ translate(mockHeroProduct.nameKey) }}</span>
                <span class="lp-mock-prod-price">{{ mockHeroProduct.price }}</span>
                <div class="lp-mock-skel lp-mock-skel-line"></div>
                <div class="lp-mock-btn lp-mock-btn-labeled">{{ translate('lp_mock_add_to_cart') }}</div>
              </div>
            </div>
            <div class="lp-mock-grid">
              <div class="lp-mock-card" *ngFor="let p of mockProducts; trackBy: trackByIndex">
                <div class="lp-mock-card-img lp-mock-card-img-photo">
                  <img [src]="p.img" [alt]="translate(p.nameKey)"
                       width="880" height="880" loading="lazy" decoding="async" />
                </div>
                <span class="lp-mock-prod-name">{{ translate(p.nameKey) }}</span>
                <span class="lp-mock-prod-price">{{ p.price }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="lp-demo-chat">
          <div class="lp-demo-chat-head">
            <div class="lp-demo-chat-head-left">
              <span class="material-icons-outlined">auto_awesome</span>
              <strong>Vendeur.site Studio</strong>
            </div>
            <button class="lp-demo-reset" type="button" (click)="resetDemo()" aria-label="Réinitialiser">
              <span class="material-icons-outlined">refresh</span>
            </button>
          </div>

          <div class="lp-demo-chat-body">
            <div class="lp-demo-msg is-ai">
              <span class="lp-demo-msg-text">{{ translate('lp_demo_ai_greeting') }}</span>
            </div>
            <div *ngFor="let m of demoMessages(); trackBy: trackByIndex"
                 class="lp-demo-msg"
                 [class.is-user]="m.role === 'user'"
                 [class.is-ai]="m.role === 'ai'">
              <span class="lp-demo-msg-text">{{ m.text }}</span>
            </div>
          </div>

          <div class="lp-demo-suggestions">
            <button *ngFor="let s of demoSuggestions; trackBy: trackByIndex"
                    class="lp-demo-suggest"
                    type="button"
                    (click)="runDemo(s.key)">
              <span class="material-icons-outlined" aria-hidden="true">bolt</span>
              {{ translate(s.labelKey) }}
            </button>
          </div>

          <div class="lp-demo-foot">
            <span class="material-icons-outlined">auto_awesome</span>
            {{ translate('lp_demo_powered') }}
          </div>
        </div>
      </div>
    </section>

    <!-- ═══════════════════════════════════════════════════════════════
         5 bis. REELS — spots de la campagne (produits par notre studio IA)
         ═══════════════════════════════════════════════════════════════ -->
    <section class="lp-section lp-reels lp-reveal" id="lp-reels" aria-labelledby="lp-reels-title">
      <header class="lp-section-head">
        <span class="lp-eyebrow">{{ translate('lp_reels_eyebrow') }}</span>
        <h2 class="lp-section-title" id="lp-reels-title">{{ translate('lp_reels_title') }}</h2>
        <p class="lp-section-sub">{{ translate('lp_reels_sub') }}</p>
      </header>

      <div class="lp-reels-grid">
        <figure class="lp-reel lp-reveal" *ngFor="let r of reels; let i = index; trackBy: trackByIndex"
                [style.--lp-stagger]="i * 110 + 'ms'">
          <div class="lp-reel-frame" (click)="playReel(r.day)"
               [class.is-playing]="reelPlaying() === r.day"
               role="button" tabindex="0"
               (keydown.enter)="playReel(r.day)"
               [attr.aria-label]="translate(r.titleKey)">
            <!-- Poster léger ; le MP4 (CDN edge) n'est chargé qu'au clic. -->
            <img *ngIf="reelPlaying() !== r.day" class="lp-reel-poster"
                 [src]="reelPoster(r.day)" [alt]="translate(r.titleKey)"
                 width="540" height="960" loading="lazy" decoding="async" />
            <video *ngIf="reelPlaying() === r.day" class="lp-reel-video"
                   [src]="reelSrc(r.day)" autoplay controls playsinline
                   [attr.aria-label]="translate(r.titleKey)"></video>
            <span class="lp-reel-play" *ngIf="reelPlaying() !== r.day" aria-hidden="true">
              <span class="material-icons-outlined">play_arrow</span>
            </span>
            <span class="lp-reel-day" aria-hidden="true">
              {{ translate('lp_reels_day') }} {{ r.day }}/7
            </span>
          </div>
          <figcaption>
            <strong>{{ translate(r.titleKey) }}</strong>
            <span>{{ translate(r.captionKey) }}</span>
          </figcaption>
        </figure>
      </div>

      <p class="lp-reels-note">
        <span class="material-icons-outlined" aria-hidden="true">auto_awesome</span>
        {{ translate('lp_reels_note') }}
      </p>
    </section>

    <!-- ═══════════════════════════════════════════════════════════════
         6. TARIFS
         ═══════════════════════════════════════════════════════════════ -->
    <section class="lp-section lp-pricing lp-reveal" id="lp-pricing" aria-labelledby="lp-pricing-title">
      <header class="lp-section-head">
        <span class="lp-eyebrow">{{ translate('lp_nav_pricing') }}</span>
        <h2 class="lp-section-title" id="lp-pricing-title">{{ translate('lp_pricing_title') }}</h2>
        <p class="lp-section-sub">{{ translate('lp_pricing_subtitle') }}</p>
      </header>

      <div class="lp-plan-grid">
        <article *ngFor="let p of plans; let i = index; trackBy: trackByIndex"
                 class="lp-plan-card lp-reveal"
                 [class.is-popular]="p.popular"
                 [attr.data-plan]="p.id"
                 [style.--lp-stagger]="i * 90 + 'ms'">
          <span class="lp-plan-badge" *ngIf="p.popular">{{ translate('lp_pricing_popular') }}</span>
          <h3 class="lp-plan-name">{{ translate(p.nameKey) }}</h3>
          <div class="lp-plan-price">
            <span class="lp-plan-price-val">{{ translate(p.priceKey) }}</span>
            <span class="lp-plan-price-period">{{ translate(p.periodKey) }}</span>
          </div>
          <ul class="lp-plan-features">
            <li *ngFor="let fk of p.featuresKeys; trackBy: trackByIndex">
              <span class="material-icons-outlined" aria-hidden="true">check_circle</span>
              {{ translate(fk) }}
            </li>
          </ul>
          <a [routerLink]="p.ctaRoute"
             class="lp-btn lp-plan-cta"
             [class.lp-btn-primary]="p.popular"
             [class.lp-btn-glass]="!p.popular">
            {{ translate(p.ctaKey) }}
          </a>
        </article>
      </div>
    </section>

    <!-- ═══════════════════════════════════════════════════════════════
         7. TÉMOIGNAGES — Carousel
         ═══════════════════════════════════════════════════════════════ -->
    <section class="lp-section lp-testimonials lp-reveal" id="lp-testimonials" aria-labelledby="lp-testimonials-title">
      <header class="lp-section-head">
        <span class="lp-eyebrow">{{ translate('lp_nav_testimonials') }}</span>
        <h2 class="lp-section-title" id="lp-testimonials-title">{{ translate('lp_testimonials_title') }}</h2>
        <p class="lp-section-sub">{{ translate('lp_testimonials_subtitle') }}</p>
      </header>

      <div class="lp-testimonial-stage">
        <button type="button" class="lp-tst-nav lp-tst-nav-prev" (click)="prevTestimonial()" aria-label="Précédent">
          <span class="material-icons-outlined">chevron_left</span>
        </button>

        <div class="lp-tst-grid">
          <article *ngFor="let t of visibleTestimonials(); trackBy: trackByIndex" class="lp-tst-card">
            <div class="lp-tst-stars">
              <span *ngFor="let _ of starsArray(t.rating); trackBy: trackByIndex" class="material-icons-outlined">star</span>
            </div>
            <p class="lp-tst-quote">« {{ translate(t.quoteKey) }} »</p>
            <div class="lp-tst-author">
              <span class="lp-tst-avatar" [style.background]="t.avatarBg" [style.color]="t.avatarFg">
                {{ translate(t.nameKey).charAt(0) }}
              </span>
              <div class="lp-tst-meta">
                <strong>{{ translate(t.nameKey) }}</strong>
                <span>{{ translate(t.roleKey) }}</span>
              </div>
            </div>
          </article>
        </div>

        <button type="button" class="lp-tst-nav lp-tst-nav-next" (click)="nextTestimonial()" aria-label="Suivant">
          <span class="material-icons-outlined">chevron_right</span>
        </button>
      </div>

      <div class="lp-tst-dots" role="tablist">
        <button *ngFor="let t of testimonials; let i = index; trackBy: trackByIndex"
                class="lp-tst-dot"
                type="button"
                role="tab"
                [class.is-active]="i === testimonialIndex()"
                (click)="testimonialIndex.set(i)"
                [attr.aria-label]="'Témoignage ' + (i + 1)"></button>
      </div>
    </section>

    <!-- ═══════════════════════════════════════════════════════════════
         8. FAQ
         ═══════════════════════════════════════════════════════════════ -->
    <section class="lp-section lp-faq lp-reveal" id="lp-faq" aria-labelledby="lp-faq-title">
      <header class="lp-section-head">
        <span class="lp-eyebrow">FAQ</span>
        <h2 class="lp-section-title" id="lp-faq-title">{{ translate('lp_faq_title') }}</h2>
        <p class="lp-section-sub">{{ translate('lp_faq_subtitle') }}</p>
      </header>

      <div class="lp-faq-list">
        <div *ngFor="let faq of faqs; let i = index; trackBy: trackByIndex"
             class="lp-faq-item"
             [class.is-open]="faq.open()">
          <button class="lp-faq-q" type="button" (click)="toggleFaq(faq)" [attr.aria-expanded]="faq.open()">
            <span>{{ translate(faq.qKey) }}</span>
            <span class="lp-faq-chevron material-icons-outlined" aria-hidden="true">expand_more</span>
          </button>
          <div class="lp-faq-a-wrap">
            <p class="lp-faq-a">{{ translate(faq.aKey) }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ═══════════════════════════════════════════════════════════════
         9. CTA FINAL FULLSCREEN
         ═══════════════════════════════════════════════════════════════ -->
    <section class="lp-cta-final lp-reveal" id="lp-cta" aria-labelledby="lp-cta-title">
      <div class="lp-orb lp-orb-cta-1" aria-hidden="true"></div>
      <div class="lp-orb lp-orb-cta-2" aria-hidden="true"></div>
      <div class="lp-cta-inner">
        <h2 class="lp-cta-title" id="lp-cta-title">{{ translate('lp_cta_final_title') }}</h2>
        <p class="lp-cta-sub">{{ translate('lp_cta_final_subtitle') }}</p>
        <div class="lp-cta-buttons">
          <a routerLink="/signup" class="lp-btn lp-btn-primary lp-btn-xl">
            <span class="material-icons-outlined" aria-hidden="true">rocket_launch</span>
            {{ translate('lp_cta_final_primary') }}
          </a>
          <button type="button" class="lp-btn lp-btn-ghost-light lp-btn-xl" (click)="toggleChatbot()">
            <span class="material-icons-outlined" aria-hidden="true">support_agent</span>
            {{ translate('lp_cta_final_secondary') }}
          </button>
        </div>
      </div>
    </section>

  </main>

  <!-- ═══════════════════════════════════════════════════════════════════
       10. FOOTER RICHE
       ═══════════════════════════════════════════════════════════════════ -->
  <footer class="lp-footer" role="contentinfo">
    <div class="lp-footer-cols">
      <div class="lp-footer-col lp-footer-brand-col">
        <a class="lp-brand" routerLink="/" aria-label="vendeur.site">
          <app-brand-logo size="sm" [animated]="false"></app-brand-logo>
          <span class="lp-brand-word">vendeur<span class="lp-brand-dot">.</span>site</span>
        </a>
        <p class="lp-footer-tagline">{{ translate('lp_footer_tagline') }}</p>
        <div class="lp-footer-social">
          <a href="https://facebook.com/vendeur.site" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <span class="material-icons-outlined">facebook</span>
          </a>
          <a href="https://instagram.com/vendeur.site" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <span class="material-icons-outlined">photo_camera</span>
          </a>
          <a href="https://wa.me/21612345678" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
            <span class="material-icons-outlined">chat</span>
          </a>
        </div>
      </div>

      <div class="lp-footer-col">
        <h4>{{ translate('lp_footer_col_product') }}</h4>
        <ul>
          <li><button type="button" (click)="scrollToSection('lp-features')">{{ translate('lp_footer_link_builder') }}</button></li>
          <li><button type="button" (click)="scrollToSection('lp-features')">{{ translate('lp_footer_link_inbox') }}</button></li>
          <li><button type="button" (click)="scrollToSection('lp-features')">{{ translate('lp_footer_link_analytics') }}</button></li>
          <li><button type="button" (click)="scrollToSection('lp-features')">{{ translate('lp_footer_link_shipping') }}</button></li>
          <li><button type="button" (click)="scrollToSection('lp-pricing')">{{ translate('lp_footer_link_pricing') }}</button></li>
        </ul>
      </div>

      <div class="lp-footer-col">
        <h4>{{ translate('lp_footer_col_resources') }}</h4>
        <ul>
          <li><a href="#" rel="noopener">{{ translate('lp_footer_link_docs') }}</a></li>
          <li><a href="#" rel="noopener">{{ translate('lp_footer_link_templates') }}</a></li>
          <li><a href="#" rel="noopener">{{ translate('lp_footer_link_blog') }}</a></li>
          <li><a href="#" rel="noopener">{{ translate('lp_footer_link_changelog') }}</a></li>
        </ul>
      </div>

      <div class="lp-footer-col">
        <h4>{{ translate('lp_footer_col_legal') }}</h4>
        <ul>
          <li><a routerLink="/legal/terms">{{ translate('lp_footer_link_terms') }}</a></li>
          <li><a routerLink="/legal/privacy">{{ translate('lp_footer_link_privacy') }}</a></li>
          <li><a routerLink="/legal/privacy">{{ translate('lp_footer_link_cookies') }}</a></li>
          <li><a [href]="'mailto:' + contactInfo.email">{{ translate('lp_footer_link_contact') }}</a></li>
        </ul>
      </div>
    </div>

    <div class="lp-footer-bottom">
      <span>{{ translate('footer_copyright') }}</span>
      <div class="lp-footer-bottom-right">
        <div class="lp-lang-picker lp-lang-picker-footer">
          <span class="material-icons-outlined" aria-hidden="true">language</span>
          <select (change)="changeLanguage($event)" aria-label="Langue">
            <option *ngFor="let lang of availableLanguages" [value]="lang.code" [selected]="lang.code === currentLanguage.code">
              {{ lang.name }}
            </option>
          </select>
        </div>
        <button class="lp-theme-toggle" type="button" (click)="toggleTheme()" aria-label="Thème">
          <span class="material-icons-outlined">{{ isDark() ? 'light_mode' : 'dark_mode' }}</span>
        </button>
      </div>
    </div>
  </footer>

  <!-- ═══════════════════════════════════════════════════════════════════
       11. CHATBOT FAB + PANEL (logique préservée, relook)
       ═══════════════════════════════════════════════════════════════════ -->
  <button class="lp-chatbot-fab" type="button" (click)="toggleChatbot()" [class.is-open]="isChatbotOpen()" aria-label="Assistant vendeur.site">
    <span class="material-icons-outlined" *ngIf="!isChatbotOpen()">support_agent</span>
    <span class="material-icons-outlined" *ngIf="isChatbotOpen()">close</span>
    <span class="lp-chatbot-fab-ring" aria-hidden="true"></span>
    <span class="lp-chatbot-fab-badge" *ngIf="!isChatbotOpen()" aria-hidden="true">1</span>
  </button>

  <aside class="lp-chatbot-panel" *ngIf="isChatbotOpen()" role="dialog" aria-label="Assistant vendeur.site">
    <header class="lp-chat-head">
      <div class="lp-chat-avatar">
        <span class="material-icons-outlined">auto_awesome</span>
      </div>
      <div class="lp-chat-info">
        <strong>{{ translate('lp_chatbot_title') }}</strong>
        <span class="lp-chat-status">
          <span class="lp-live-dot"></span>
          {{ translate('lp_chatbot_status') }}
        </span>
      </div>
      <button class="lp-chat-icon-btn" type="button" (click)="resetChat()" [attr.aria-label]="'Reset'">
        <span class="material-icons-outlined">restart_alt</span>
      </button>
      <button class="lp-chat-icon-btn" type="button" (click)="toggleChatbot()" aria-label="Fermer">
        <span class="material-icons-outlined">close</span>
      </button>
    </header>

    <div class="lp-chat-body" id="lp-chat-messages">
      <div *ngFor="let m of messages(); trackBy: trackByIndex"
           class="lp-chat-msg"
           [class.is-user]="m.sender === 'user'"
           [class.is-bot]="m.sender === 'bot'">
        <div class="lp-chat-bubble">
          <p>{{ m.text }}</p>
          <span class="lp-chat-time">{{ formatTime(m.timestamp) }}</span>
        </div>
      </div>
      <div class="lp-chat-msg is-bot" *ngIf="isTyping()">
        <div class="lp-chat-bubble lp-chat-bubble-typing">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>

    <div class="lp-chat-identity" *ngIf="!chatIdentified()">
      <h5>
        <span class="material-icons-outlined">badge</span>
        Avant de discuter
      </h5>
      <p class="lp-chat-identity-hint">
        Laissez vos coordonnées pour qu’on puisse vous recontacter et reprendre cette discussion.
      </p>
      <label class="lp-chat-identity-label">Nom *</label>
      <input class="lp-chat-input" type="text" autocomplete="name"
             [value]="visitorName()"
             (input)="visitorName.set($any($event.target).value)"
             placeholder="Votre nom" />
      <label class="lp-chat-identity-label">Email</label>
      <input class="lp-chat-input" type="email" autocomplete="email"
             [value]="visitorEmail()"
             (input)="visitorEmail.set($any($event.target).value)"
             placeholder="vous@exemple.com" />
      <label class="lp-chat-identity-label">Téléphone</label>
      <input class="lp-chat-input" type="tel" autocomplete="tel"
             [value]="visitorPhone()"
             (input)="visitorPhone.set($any($event.target).value)"
             placeholder="+216 …" />
      <p class="lp-chat-identity-hint">Email ou téléphone obligatoire.</p>
      <p class="lp-chat-identity-err" *ngIf="chatIdentityError()">{{ chatIdentityError() }}</p>
      <button class="lp-btn lp-btn-primary lp-btn-sm" type="button"
              [disabled]="chatIdentityBusy()"
              (click)="submitVisitorIdentity()">
        <span class="material-icons-outlined">forum</span>
        Commencer la discussion
      </button>
    </div>

    <div class="lp-chat-quick" *ngIf="chatIdentified() && showQuickQuestions() && !showContactInfo()">
      <h5>
        <span class="material-icons-outlined">bolt</span>
        {{ translate('lp_chatbot_quick_questions') }}
      </h5>
      <div class="lp-chat-chips">
        <button *ngFor="let q of quickQuestions; trackBy: trackByIndex"
                class="lp-chat-chip"
                type="button"
                (click)="handleQuestionClick(q)">
          {{ translate(q.questionKey) }}
        </button>
      </div>
    </div>

    <div class="lp-chat-contact" *ngIf="chatIdentified() && showContactInfo()">
      <h5>{{ translate('lp_chatbot_contact_title') }}</h5>
      <a [href]="'mailto:' + contactInfo.email" class="lp-chat-contact-row">
        <span class="material-icons-outlined">mail</span>
        <div>
          <strong>{{ translate('lp_chatbot_contact_email') }}</strong>
          <span>{{ contactInfo.email }}</span>
        </div>
      </a>
      <a [href]="'tel:' + contactInfo.phone" class="lp-chat-contact-row">
        <span class="material-icons-outlined">call</span>
        <div>
          <strong>{{ translate('lp_chatbot_contact_phone') }}</strong>
          <span>{{ contactInfo.phone }}</span>
        </div>
      </a>
      <div class="lp-chat-contact-row">
        <span class="material-icons-outlined">schedule</span>
        <div>
          <strong>{{ translate('lp_chatbot_contact_hours_label') }}</strong>
          <span>{{ translate(contactInfo.hoursKey) }}</span>
        </div>
      </div>
    </div>

    <div class="lp-chat-actions" *ngIf="chatIdentified()">
      <button class="lp-btn lp-btn-glass lp-btn-sm" type="button" (click)="showContact()" *ngIf="!showContactInfo()">
        <span class="material-icons-outlined">call</span>
        {{ translate('lp_chatbot_contact_direct') }}
      </button>
      <button class="lp-btn lp-btn-primary lp-btn-sm" type="button" (click)="switchToChatMode()">
        <span class="material-icons-outlined">forum</span>
        {{ translate('lp_chatbot_quick_questions') }}
      </button>
    </div>

    <!-- Composer LIVE : question libre → bot marketing (Vendy) -->
    <form class="lp-chat-composer" *ngIf="chatIdentified()" (submit)="$event.preventDefault(); sendLiveMessage()">
      <input type="text"
             class="lp-chat-input"
             [placeholder]="translate('lp_chatbot_input_placeholder')"
             [value]="chatDraft()"
             (input)="chatDraft.set($any($event.target).value)"
             maxlength="1000"
             autocomplete="off" />
      <button class="lp-chat-send" type="submit" [disabled]="!chatDraft().trim()"
              [attr.aria-label]="translate('lp_chatbot_send')">
        <span class="material-icons-outlined">send</span>
      </button>
    </form>

    <footer class="lp-chat-foot">
      <span class="material-icons-outlined">auto_awesome</span>
      {{ translate('lp_chatbot_powered') }}
    </footer>
  </aside>

</div>
